// @need-translate
import css from 'styled-jsx/css';
import {PolicyType} from '../../common/shared/utils/PolicyType.enum';
import {MainTabItemType} from '../../design-system/organisms/MainTab/MainTabItemType.interface';
import {theme} from '../../theme';
import {KakaoentPolicyType} from './type';
import {getKakaoentPolicyUrl} from './util/getKakaoentPolicyUrl';

/**
 * https://podotree.atlassian.net/browse/KW-5704?focusedCommentId=186997
 * 기획서에 아직 업데이트 되지 않아 코멘트로 참고 링크 첨부합니다.
 */
export const POLICY_TITLE_MAP: {[key in PolicyType]: string} = {
  [PolicyType.Terms]: '카카오페이지 이용약관',
  [PolicyType.Privacy]: '카카오페이지 개인정보처리방침',
  [PolicyType.TermsPaid]: '카카오페이지 유료서비스 이용약관',
  [PolicyType.SafeGuard]: '카카오페이지 청소년보호정책',
  [PolicyType.Operation]: '서비스 운영정책',
  [PolicyType.Right]: '카카오페이지 권리침해신고센터',
  [PolicyType.Marketing]: '무료이용권 및 캐시선물 수신 알림 동의',
  [PolicyType.Friends]: '카카오페이지 카카오톡 채널 추가 동의',
  [PolicyType.PersonalInformation]: '카카오페이지 개인정보 제3자 제공 동의',
  [PolicyType.PersonalInformationCollection]:
    '카카오페이지 개인정보 수집 및 이용 안내',
  [PolicyType.PersonalInformationThirdParty]: '제3자 정보제공 동의',
  [PolicyType.MarketingNight]: '야간(저녁8시 ~ 자정) 선물 수신 알림 동의',
  [PolicyType.UsePersonalInfo]: '개인정보 수집 및 이용 동의',
  [PolicyType.PersonalAd]: '맞춤형 광고 및 콘텐츠 제공안내',
  [PolicyType.PaymentService]: '카카오페이지 결제서비스 운영정책',
  [PolicyType.PrivacySafe]: '카카오페이지 정보보호 안내',
  [PolicyType.MarketingThird]: '마케팅 활용 개인정보 제3자 제공 동의',
  // 14세 관련 약관
  [PolicyType.LegalAgentPrivacy]:
    '보호자(법정대리인)의 개인정보 수집 및 이용 안내',
  [PolicyType.ChildPrivacy]: '아동의 개인정보 수집 및 이용 동의',
  [PolicyType.ChildPersonalInformationThird]:
    '아동의 카카오페이지 개인정보 제3자 제공 동의',
  [PolicyType.ChildMarketingThird]:
    '아동의 마케팅 활용 개인정보 제3자 제공 동의',
};

export const POLICY_TAB: MainTabItemType[] = [
  {
    id: PolicyType.Terms as string,
    text: '이용약관',
    textTKey: 'common_footer_term_use',
    href: `/policy/${PolicyType.Terms}`,
  },
  {
    id: PolicyType.Privacy as string,
    text: '개인정보처리방침',
    textTKey: 'common_footer_term_privacy',
    href: getKakaoentPolicyUrl({
      type: KakaoentPolicyType.Policy,
    }).urlExcludeVod().href,
    shouldOpenNewTab: true,
  },
  {
    id: PolicyType.Operation as string,
    text: '운영정책',
    textTKey: 'more_customer_terms_operational',
    href: `/policy/${PolicyType.Operation}`,
  },
  {
    id: PolicyType.SafeGuard as string,
    text: '청소년보호정책',
    textTKey: 'common_footer_term_youth',
    href: `/policy/${PolicyType.SafeGuard}`,
  },
  {
    id: PolicyType.Right as string,
    text: '권리침해신고센터',
    textTKey: 'reportcomment_option_7_link',
    href: `/policy/${PolicyType.Right}`,
  },
  {
    id: PolicyType.PrivacySafe as string,
    text: '정보보호인증',
    textTKey: 'more_customer_terms_certification',
    href: `/policy/${PolicyType.PrivacySafe}`,
  },
  {
    id: PolicyType.PersonalInformationThirdParty as string,
    text: '개인정보 제3자 제공 동의',
    textTKey: 'more_customer_terms_thirdparty_agree_more',
    href: `/policy/${PolicyType.PersonalInformationThirdParty}`,
  },
];

export const PolicyPageStyle = css`
  .policy-content-container :global(*) {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
  }
  .policy-content-container :global(header) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .policy-content-container :global(h2) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .policy-content-container :global(h3) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .policy-content-container :global(h4) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .policy-content-container :global(p) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .policy-content-container :global(li) {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .policy-content-container :global(header) {
    font-size: 21px;
    font-weight: 700;
    line-height: 26px;
    margin-top: 24px;
    margin-bottom: 12px;
  }
  .policy-content-container :global(main) {
    margin-bottom: 16px;
  }
  .policy-content-container :global(h2) {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }
  .policy-content-container :global(h3) {
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
  }
  .policy-content-container :global(h4) {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
  .policy-content-container :global(section) {
    margin-bottom: 8px;
  }
  .policy-content-container :global(ol) {
    padding-left: 17px;
    list-style-type: none;
  }
  .policy-content-container :global(ol li) {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    color: ${theme.colors['theme-solid-100']};
  }
  .policy-content-container :global(ol li span) {
    width: 20px;
    display: inline-block;
    margin-left: -20px;
    text-align: center;
  }
  .policy-content-container :global(ol li.number-circle-li span) {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
  .policy-content-container :global(.inner-ol li) {
    color: ${theme.colors['theme-solid-60']};
  }
  .policy-content-container :global(.inner-ol li span) {
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 16px !important;
  }
  .policy-content-container :global(.inner-ol li:last-child) {
    padding-bottom: 0px;
  }
  .policy-content-container :global(ul) {
    color: ${theme.colors['theme-solid-60']};
    padding-left: 13px;
    list-style-type: none;
  }
  .policy-content-container :global(ul li) {
    padding-left: 8px;
    padding-right: 8px;
  }
  .policy-content-container :global(ul li::before) {
    display: inline-block;
    width: 2px;
    height: 2px;
    margin: 6px 5px 0 -8px;
    background-color: ${theme.colors['theme-solid-60']};
    line-height: 14px;
    vertical-align: text-top;
    border-radius: 50%;
    content: '';
  }
  .policy-content-container :global(a) {
    text-decoration: underline;
    text-decoration-color: inherit;
  }
  .policy-content-container :global(hr) {
    margin-top: 20px;
    margin-bottom: 28px;
    border-top-width: 1px;
    border-color: ${theme.colors['theme-solid-20']};
  }
  .policy-content-container :global(table) {
    margin: 16px auto;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    width: 100%;
    border-collapse: collapse;
  }
  .policy-content-container :global(table th) {
    background-color: ${theme.colors['theme-solid-10']};
  }
  .policy-content-container :global(table th) {
    padding: 12px;
    vertical-align: middle;
    text-align: left;
    border-left-width: 1px;
    border-bottom-width: 1px;
    border-color: ${theme.colors['theme-solid-20']};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
  .policy-content-container :global(table td) {
    padding: 12px;
    vertical-align: middle;
    text-align: left;
    border-left-width: 1px;
    border-bottom-width: 1px;
    border-color: ${theme.colors['theme-solid-20']};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
  .policy-content-container :global(table td > p) {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }
  .policy-content-container :global(table ul) {
    padding-left: 10px;
    color: ${theme.colors['theme-solid-100']};
  }
  .policy-content-container :global(th:first-child) {
    border-left: none;
  }
  .policy-content-container :global(td:first-child) {
    border-left: none;
  }
  .policy-content-container :global(strong) {
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
    color: inherit;
  }
  .policy-content-container :global(div) {
    margin-top: 16px;
  }
  .policy-content-container :global(button) {
    margin-top: 16px;
    background-color: ${theme.colors['theme-solid-100']};
    color: ${theme.colors['theme-solid-10']};
    border-radius: 32px;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
  }
  .policy-content-container :global(button a) {
    display: block;
    padding: 7px 14px;
  }
  .policy-content-container :global(.text-align-center-table th) {
    text-align: center;
  }
  .policy-content-container :global(.text-align-center-table td) {
    text-align: center;
  }
  .policy-content-container :global(.last-table) {
    margin-bottom: 24px;
  }
  /* TODO : 디자인 수정 이후에 개인정보이용방침 페이지의 하위 페이지에서 다시 개인정보이용방침 페이지로 이동 시 헤더 높이만큼 스크롤 위치를 조정하는 css 추가 */
`;
